<template>
    <v-row no-gutters class="d-flex justify-center" style="height: 80vh; width: 100vw">
        <v-col cols="12">
            <v-btn-back @click="routeBack()" class="ma-2" />
        </v-col>
        <v-col cols="6" class="align-self-center default_card">
            <v-row class="pa-3">
                <v-col cols="12">
                    <v-file-input
                        v-model="folder"
                        show-size
                        outlined
                        dense
                        prepend-icon="$fa-folder"
                        label="Select folder"
                        @change="setFolderData()"
                        webkitdirectory
                        multiple
                    />
                </v-col>
            </v-row>
            <v-divider />
            <v-row no-gutters class="d-flex">
                <v-col cols="6" class="pa-3">
                    <v-file-input
                        v-model="files.table"
                        show-size
                        outlined
                        dense
                        label="File Form"
                        @change="setTableFile()"
                    />
                </v-col>
                <v-col cols="6" class="pa-3">
                    <v-file-input
                        v-model="files.rules"
                        show-size
                        outlined
                        dense
                        label="File Rules"
                        @change="setRulesFile()"
                    />
                </v-col>
                <v-col cols="6" class="pa-3">
                    <v-file-input
                        v-model="files.values"
                        show-size
                        outlined
                        dense
                        label="File Values"
                        @change="setValuesFile()"
                    />
                </v-col>
                <v-col cols="6" class="pa-3">
                    <v-file-input
                        v-model="files.cerfa"
                        show-size
                        outlined
                        dense
                        label="File Cerfa JSON"
                        @change="setCerfaFile()"
                    />
                </v-col>
                <v-col cols="6" class="pa-3">
                    <v-file-input
                        v-model="files.image"
                        show-size
                        outlined
                        dense
                        label="File Cerfa Image"
                        @change="setImageFile()"
                    />
                </v-col>
                <v-col cols="12" class="d-flex justify-end pa-3">
                    <v-btn
                        class="ma-1"
                        @click="clear()"
                        @keydown.enter="clear()"
                        rounded
                        elevation="0"
                    >
                        Effacer la sélection
                    </v-btn>
                    <v-btn
                        class="ma-1"
                        rounded
                        elevation="0"
                        :disabled="!isFormValid"
                        @click="valid()"
                    >
                        Valider
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import moment from "moment-timezone";
import DELETE_TAX_FORM from "@/graphql/taxForm/DeleteTaxForm.gql";
// import TaxForm from "../TaxForm.vue";
// import TaxFormDisplayPlayground from "./TaxFormDisplayPlayground.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

// import { Apollo } from "@/decorators";

// import gql from "graphql-tag";
// import UPSERT_TAX_FORM from "@/graphql/taxForm/UpsertTaxForm.gql";

@Component({
    components: {
        // TaxForm,
        // TaxFormDisplayPlayground,
    },
    emits: ["routeBack", "forms", "delete"],
})
export class UploadTaxFrom extends Vue {
    activeTaxForm = "TaxFormTable";

    taxFormTableJson = null;
    taxFormRulesJson = null;
    taxFormValuesJson = null;
    taxFormCerfaJson = null;
    taxFormCerfaImage = null;
    taxFormID = null;

    activeTab: string = "";
    dialog: boolean = false;

    dialogMillesim: boolean = false;
    millesim: any = null;
    millesimItems: any = [];

    result = null;
    theyIsID: boolean = false;

    reloadKey = 0;

    files: any = {
        table: null,
        rules: null,
        values: null,
        cerfa: null,
        image: null,
    };

    folder = null;
    displayCerfa: boolean = false;

    get getId() {
        if (this.$route.params.id) {
            this.theyIsID = true;
        }
        return this.$route.params.id;
    }

    setCurrentYear() {
        let year: any = moment().year();
        year = year + 1;
        this.millesimItems = [year, year - 1, year - 2, year - 3].sort().reverse();
    }

    get isFormValid() {
        return this.files.table && this.files.rules && this.files.values;
    }

    get jsonToDisplay() {
        return this.displayCerfa ? this.taxFormTableJson : this.taxFormCerfaJson;
    }

    get idForm() {
        return this.idForm;
    }

    routeBack() {
        return this.$emit("routeBack");
    }

    setTableFile() {
        const reader = new FileReader();
        const self = this;
        reader.onload = (e) => {
            const text = e.target.result as string;
            self.taxFormTableJson = JSON.parse(text);
        };
        reader.readAsText(this.files.table);
    }

    setRulesFile() {
        const reader = new FileReader();
        const self = this;
        reader.onload = (e) => {
            const text = e.target.result as string;
            self.taxFormRulesJson = JSON.parse(text);
        };
        reader.readAsText(this.files.rules);
    }

    setValuesFile() {
        const reader = new FileReader();
        const self = this;
        reader.onload = (e) => {
            const text = e.target.result as string;
            self.taxFormValuesJson = JSON.parse(text);
        };
        reader.readAsText(this.files.values);
    }

    setCerfaFile() {
        const reader = new FileReader();
        const self = this;
        reader.onload = (e) => {
            const text = e.target.result as string;
            self.taxFormCerfaJson = JSON.parse(text);
        };
        reader.readAsText(this.files.cerfa);
    }

    setImageFile() {
        const reader = new FileReader();
        const self = this;
        this.files.values; // Blob
        reader.onload = (e) => {
            self.taxFormCerfaImage = e.target.result;
        };
        reader.readAsDataURL(this.files.image);
    }

    valid() {
        debugger;
        this.$emit("forms", {
            form: this.taxFormTableJson,
            rules: this.taxFormRulesJson,
            values: this.taxFormValuesJson,
            cerfa: this.taxFormCerfaJson,
            image: this.taxFormCerfaImage,
        });
    }

    async delete() {
        debugger;
        if (this.files) {
            try {
                await this.$apollo.mutate({
                    mutation: DELETE_TAX_FORM,
                    variables: {
                        id: this.idForm,
                    },
                });
            } catch (error) {
                console.log(error);
            }
            this.$emit("deleted");
            console.log("delete done !");
        }
        return;
    }

    clear() {
        debugger;
        (this.folder = null),
            (this.files = {
                table: null,
                rules: null,
                values: null,
                cerfa: null,
                image: null,
            });
    }

    setFolderData() {
        for (let file of this.folder) {
            switch (file.name) {
                case "form.json":
                    this.files.table = file;
                    this.setTableFile();
                    break;
                case "rules.json":
                    this.files.rules = file;
                    this.setRulesFile();
                    break;
                case "values.json":
                    this.files.values = file;
                    this.setValuesFile();
                    break;
                case "cerfa.json":
                    this.files.cerfa = file;
                    this.setCerfaFile();
                    break;
                case "image.png":
                    this.files.image = file;
                    this.setImageFile();
                    break;
            }
        }
    }
}

export default toNative(UploadTaxFrom);
</script>

<style>
.jsoneditor-vue {
    height: 100vh;
}
</style>
